module.exports = __webpack_public_path__ + "img/rec-14.d28f4c2f.jpg";